import { MarketingQueryDetailsFragment } from 'generated/graphql';
import { UpdateMarketingQueryState } from 'stores/interfaces/UpdateQueryState';
import { SetState } from 'zustand';

export const createUpdateMarketingQuerySlice = (set: SetState<UpdateMarketingQueryState>) => ({
  setInitialStateWithProps: (queryDetails: MarketingQueryDetailsFragment) =>
    set({
      account: queryDetails.account || undefined,
      fileName: queryDetails.fileNameMkt || undefined
    })
});
